import {
  fetchWithErrorHandling,
  throwErrorsIfBadResponse,
} from '@github-ui/pull-request-page-data-tooling/fetch-error-handling'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {useMutation, useQueryClient} from '@github-ui/react-query'
import {pullRequestMarkersKey, type Markers} from '../page-data/loaders/use-markers-data'

export function useResolveThreadMutation(basePath: string) {
  const apiUrl = `${basePath}/page_data/${PageData.resolveThread}`
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({threadId}: {threadId: string}) => {
      const response = await fetchWithErrorHandling(apiUrl, {
        method: 'POST',
        body: {
          threadId,
        },
      })

      throwErrorsIfBadResponse(response)
    },
    onSuccess: (_data, variables) => {
      return queryClient.setQueryData<Markers>(pullRequestMarkersKey(basePath), oldMarkers => {
        if (!oldMarkers) {
          return undefined
        }

        if (!oldMarkers.threads[Number(variables.threadId)]) {
          return undefined
        }

        return {
          ...oldMarkers,
          threads: {
            ...oldMarkers.threads,
            [variables.threadId]: {
              ...oldMarkers.threads[Number(variables.threadId)],
              isResolved: true,
            },
          },
        }
      })
    },
  })
}
